import { useQuery } from '@tanstack/react-query';
import { api } from '../../api/client';
import type { ValidationEvidence } from '../../types';
import { formatEvoValue } from './format';

export default function ValidationEvidencePanel() {
  const q = useQuery({ queryKey: ['evolution', 'validation'], queryFn: api.evolutionValidationEvidence });
  if (q.isLoading) return <div className="panel"><div className="small faint">Loading validation evidence...</div></div>;
  if (q.isError) return <div className="panel"><div className="small" style={{ color: 'var(--red)' }}>Validation registry unavailable.</div></div>;

  return (
    <div>
      <div className="ph">Validation evidence</div>
      <div className="h2">Claim registry</div>
      <div style={{ display: 'grid', gap: 12, marginTop: 14 }}>
        {(q.data ?? []).map((item) => <EvidenceCard key={item.claim_id} item={item} />)}
      </div>
    </div>
  );
}
function EvidenceCard({ item }: { item: ValidationEvidence }) {
  const pending = item.reproducibility_status === 'requires_artifact_package';
  return (
    <div className="panel" style={{ borderLeft: `3px solid ${pending ? 'var(--amber)' : 'var(--olive)'}` }}>
      <div className="row" style={{ justifyContent: 'space-between', gap: 12, alignItems: 'flex-start' }}>
        <div>
          <div className="row" style={{ gap: 8, marginBottom: 6, flexWrap: 'wrap' }}>
            <span className="tag blue">Tier {item.tier}</span>
            <span className={`status-pill ${pending ? 'amber' : 'green'}`}>{pending ? 'package pending' : item.evidence_status}</span>
          </div>
          <div style={{ fontSize: 18, fontWeight: 700 }}>{item.claim_text}</div>
          <div className="small" style={{ color: 'var(--muted)', marginTop: 6 }}>{item.dataset} · {item.dataset_characterization}</div>
        </div>
        <div className="small faint mono">{item.last_reviewed}</div>
      </div>
      {item.display_metrics && item.metric_summary && (
        <div className="grid2" style={{ marginTop: 12 }}>
          {Object.entries(item.metric_summary).map(([key, value]) => (
            <div className="kpi" key={key}>
              <div className="num">{formatEvoValue(value)}</div>
              <div className="lab">{key}</div>
            </div>
          ))}
        </div>
      )}
      <div className="field" style={{ marginTop: 12 }}>
        <div className="field-label">Scope limit</div>
        <div className="field-value">{item.scope_limit}</div>
      </div>
      <div className="small faint">artifact: <span className="mono">{item.artifact_ref ?? 'none'}</span></div>
    </div>
  );
}
